export const MOBILE_WIDTH = 600;
export const AP_BUTTONS_MOBILE_WIDTH = 430;

export const WAVEFORM_SAMPLES = 512;
